import { render } from "./incrediIconButton.vue?vue&type=template&id=6294227e&scoped=true"
import script from "./incrediIconButton.vue?vue&type=script&lang=js"
export * from "./incrediIconButton.vue?vue&type=script&lang=js"

import "./incrediIconButton.vue?vue&type=style&index=0&id=6294227e&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6294227e"]])

export default __exports__